import { types } from 'mobx-state-tree';
import { optionalMaybeNull } from '../mobx-utils';

import { fetchApiEndpoint } from './flows/get-api-endpoint';
import { loadable } from '../mobx-utils';

export const UpgradeModel = types.model('UpgradeModel', {
  // Admin attributes
  name: types.string,
  description: types.string,
  highlight: types.string,
  imageUrl: types.string,
  priceEuro: types.number,
  priceChf: types.number,
  priceType: types.string,
  sortingField: types.optional(types.number, 0),

  // Blank Attributes
  code: types.string,
  requestType: types.string,
  fromDate: types.maybe(types.Date),
  toDate: types.maybe(types.Date),
});

export const UpgradeStore = types.model('UpgradeStore', {
  upgrades: loadable(
    types.array(optionalMaybeNull(UpgradeModel)),
    fetchApiEndpoint('/api/upgrades'),
  ),
});
